import { render, staticRenderFns } from "./product-tj.vue?vue&type=template&id=3f68fb92&scoped=true&"
import script from "./product-tj.vue?vue&type=script&lang=js&"
export * from "./product-tj.vue?vue&type=script&lang=js&"
import style0 from "./product-tj.vue?vue&type=style&index=0&id=3f68fb92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f68fb92",
  null
  
)

export default component.exports